/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiLink } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import type { AnyAdminProject } from '@modules/project-admin-api/types'
import genericMessages from '@modules/project-lib/genericMessages'

// eslint-disable-next-line import/no-restricted-paths
import { getConfigForKey } from '@/store'

type Props = {
  project: AnyAdminProject
}

const KubernetesCluster: React.FunctionComponent<Props> = ({ project }) => {
  const clusterId = project.clusters?.elasticsearch

  if (!clusterId) {
    return <FormattedMessage {...genericMessages.na} />
  }

  const mkiOverviewDashboardUrl = getMkiOverviewDashboardUrl(project)

  if (!mkiOverviewDashboardUrl) {
    return null
  }

  return (
    <EuiLink external={true} href={mkiOverviewDashboardUrl} target='_blank'>
      {clusterId}
    </EuiLink>
  )
}

function getMkiOverviewDashboardUrl(project: AnyAdminProject): string | null {
  const o11yDomain = getConfigForKey(`CLOUD_SERVERLESS_O11Y_DOMAIN`)

  if (!o11yDomain) {
    return null
  }

  if (!project.clusters?.elasticsearch) {
    return null
  }

  return `https://${o11yDomain}/app/dashboards#/view/Infra-k8s-Cluster-Overview?_g=(filters:!((query:(match_phrase:(orchestrator.cluster.name:${project.clusters.elasticsearch})))))`
}

export default KubernetesCluster
